export enum PhotoCallUpActionTypes {
	RETRIEVE_ENROLLMENT_USER_INFO = 'RETRIEVE_ENROLLMENT_USER_INFO',
	OPEN_CONFIGURATION = 'OPEN_CONFIGURATION',
	SET_PHOTOCALLUP_USER_CONFIGURATION = 'SET_PHOTOCALLUP_USER_CONFIGURATION',
	SAVE_CONFIGURATION = 'SAVE_CONFIGURATION',
	CONFIGURATION_SAVE_NOTIFICATION = 'CONFIGURATION_SAVE_NOTIFICATION',
	CLOSE_CONFIGURATION = 'CLOSE_CONFIGURATION',
	SET_MODAL_LOADING = 'SET_MODAL_LOADING',
}
